import { useTheme } from "../../context/ThemeProvider";

const PhotonLogo = ({ wordmark = false, className = "" }) => {
  const { theme } = useTheme();
  const photonMark = `${process.env.PUBLIC_URL || ""}/qz-photon-penrose${theme === "dark" ? "-dark" : ""}.svg`;

  if (!wordmark) {
    return <img src={photonMark} alt="Photon logo" className={`object-contain ${className}`} />;
  }

  return (
    <span role="img" aria-label="Photon logo" className={`inline-flex items-center gap-2 ${className}`}>
      <img src={photonMark} alt="" aria-hidden="true" className="h-full w-auto object-contain flex-shrink-0" />
      <span aria-hidden="true" className="font-normal leading-none" style={{ color: 'var(--photon-chat-text)' }}>Photon</span>
    </span>
  );
};

export default PhotonLogo;